module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "page-title bg-theme color-theme"
  }, [_vm._v("Icon")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("normal")]), _vm._v(" "), _c('mt-icon', {
    attrs: {
      "name": "icon-pinglun"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("size")]), _vm._v(" "), _c('mt-icon', {
    attrs: {
      "name": "icon-pinglun",
      "size": "30px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("padding")]), _vm._v(" "), _c('mt-icon', {
    attrs: {
      "name": "icon-pinglun",
      "padding": "20px 20px 20px 20px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("color")]), _vm._v(" "), _c('mt-icon', {
    attrs: {
      "name": "icon-pinglun",
      "color": "green"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("click")]), _vm._v(" "), _c('mt-icon', {
    attrs: {
      "name": "icon-pinglun"
    },
    on: {
      "click": _vm.doSome
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("click-colorChange")]), _vm._v(" "), _c('mt-icon', {
    attrs: {
      "name": "icon-wifi",
      "changecolor": "red"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("animate")]), _vm._v(" "), _c('mt-icon', {
    attrs: {
      "name": "icon-pinglun",
      "animate": "animated shake"
    }
  })], 1), _vm._v(" "), _vm._m(0, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "link"
  }, [_c('a', {
    staticClass: "mt-bg-link",
    attrs: {
      "href": "http://res.wisedu.com/fe_components/iconfont_mobile/demo_fontclass.html",
      "target": "_blank"
    }
  }, [_vm._v("点击查看所有字体图标")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09b8bbe8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/icon.vue
// module id = 536
// module chunks = 0